import {
  Box,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
  styled,
} from "@mui/material";
import React from "react";
import {
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { palette, theme as colorTheme } from "../../../Convoze.theme";


const primary = colorTheme('palette', 'primary').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;



const focusAreas = [
  {
    id: 1,
    title: "Tone Consistency",
    description:
      "Needs immediate attention. Your tone score varies significantly across different call types.",
    backgroundColor: "#ffebee",
    iconColor: negative,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        ></path>
      </svg>
    ),
    bdColor: "rgb(254 226 226 / var(--tw-border-opacity, 1))",
  },
  {
    id: 2,
    title: "Silence Duration",
    description:
      "Average silence duration is trending upward. Focus on minimizing hold times.",
    backgroundColor: "#fff8e1",
    iconColor: "rgb(234 179 8 / var(--tw-text-opacity, 1))",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        ></path>
      </svg>
    ),
    bdColor: "rgb(254 249 195 / var(--tw-border-opacity, 1))",
  },
  {
    id: 3,
    title: "Empathy Score",
    description:
      "Great improvement! Your empathy score has increased by 15% this month.",
    backgroundColor: "#e8f5e8",
    iconColor: positive,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-green-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        ></path>
      </svg>
    ),
    bdColor: "rgb(220 252 231 / var(--tw-border-opacity, 1))",
  },
];
const FocusAreaItem = styled(Box)(({ theme, bgcolor, bdColor }) => ({
  backgroundColor: bgcolor,
  border: `1px solid ${bdColor}`,
  borderRadius: 8,
  padding: theme.spacing(1.5),
//   marginBottom: theme.spacing(2),
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(2),
  "&:last-child": {
    marginBottom: 0,
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1.5),
    gap: theme.spacing(1.5),
  },
}));
function FocusArea() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          gap:3
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 0,
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h6"}
            component="h1"
            fontWeight="600"
            color="text.primary"
            sx={{ textAlign: isMobile ? "center" : "left" }}
          >
            Focus Areas
          </Typography>
        </Box>

        <Stack spacing={1} >
          {focusAreas?.map((area) => {
            const IconComponent = area?.icon;
            return (
              <FocusAreaItem
                key={area?.id}
                bgcolor={area?.backgroundColor}
                bdColor={area?.bdColor}
              >
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    color: area.iconColor,
                    display: "flex",
                    justifyContent: "center",
                    alignItem: "center",
                  }}
                >
                  {/* <IconComponent
                    sx={{
                      color: area?.iconColor,
                      fontSize: isMobile ? 20 : 24,
                    }}
                  /> */}

                  {area?.icon}
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="text.primary"
                    gutterBottom
                    fontSize={13}
                  >
                    {area?.title}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.5 }}
                  >
                    {area?.description}
                  </Typography>
                </Box>
              </FocusAreaItem>
            );
          })}
        </Stack>
      </Paper>
    </>
  );
}

export default FocusArea;
